export enum SettingId {
    DarkMode = 'dark-mode',
    ExampleMultipleChoiceSetting = 'multiple-choice',
}
